"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

type Industry = {
  title: string;
  standard: string[];
  special: string[];
};

export default function SpecialFeaturesSection({
  industries,
}: {
  industries: Industry[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 px-6 max-w-6xl mx-auto">
      <div className="mb-14 text-center">
        <h2 className="text-3xl md:text-4xl font-semibold mb-4">
          Funktionen, die sich Ihrer Branche anpassen
        </h2>
        <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto">
          Standard kann jeder. Entscheidend ist, was im Alltag wirklich Zeit
          spart.
        </p>
      </div>

      <div className="space-y-10">
        {industries.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className="border rounded-2xl p-7 md:p-8 transition-all hover:shadow-md"
            >
              {/* TITLE */}
              <h3 className="text-xl md:text-2xl font-semibold mb-5">
                {item.title}
              </h3>

              {/* SPECIAL (JETZT IMMER SICHTBAR) */}
              <div className="mb-6">
                <p className="text-base font-semibold mb-4 text-primary">
                  Branchen-Sonderfunktionen
                </p>

                <ul className="space-y-3 text-base font-semibold">
                  {item.special.map((s, i) => (
                    <li key={i}>✓ {s}</li>
                  ))}
                </ul>
              </div>

              {/* BUTTON */}
              <button
                onClick={() => toggle(index)}
                className={`group inline-flex items-center gap-2 text-base font-semibold px-6 py-3 rounded-xl transition-all
                  ${
                    isOpen
                      ? "bg-primary text-primary-foreground"
                      : "bg-primary/10 text-primary hover:bg-primary/20"
                  }
                `}
              >
                {isOpen
                  ? "Standardfunktionen ausblenden"
                  : "Standardfunktionen anzeigen"}

                <ChevronDown
                  size={18}
                  className={`transition-transform duration-300 ${
                    isOpen ? "rotate-180" : "group-hover:translate-y-0.5"
                  }`}
                />
              </button>

              {/* STANDARD (JETZT AUSKLAPPBAR) */}
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  isOpen
                    ? "max-h-96 opacity-100 mt-6 pt-6 border-t bg-muted/30 rounded-xl px-5 py-5"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-base font-medium text-muted-foreground mb-4">
                  Standardfunktionen
                </p>

                <ul className="space-y-2 text-base">
                  {item.standard.map((s, i) => (
                    <li key={i}>• {s}</li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
